import { render, staticRenderFns } from "./AnswerUserInput.vue?vue&type=template&id=3b4f98d0&"
import script from "./AnswerUserInput.vue?vue&type=script&lang=js&"
export * from "./AnswerUserInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports